<!-- click listener is required for video start and google tag manager measures -->
<ng-container *ngIf="vm | contentCoreData | async as coreContentData">
  <a tabindex="0" [state]="navigationState" [routerLink]="(vm | contentCoreData | async)?.routerLink">
    <div
      class="card"
      [class.no-shadow]="hideShadow"
      osnSharedPreviewOverlay
      [preventHover]="preventHover"
      [overlayVm]="vm | shallowPreviewOverlayVmPipe: previewImgQuery | async"
      (hovered)="onCarouselItemHovered($event)"
      (itemSelect)="onCarouselItemSelected($event)"
      [@openClose]="hovered ? 'open' : 'closed'"
    >
      <div osnSharedAspectRatio="{{ aspectRatio }}">
        <img osnSharedUseAsPicture class="bg-image" [src]="getImageUrl(coreContentData)" [imgQuery]="imgQuery" [alt]="vm.title.en" />
      </div>
      <div *ngIf="showSeoTitle" class="seo-carousel-item-title">{{ vm.title | currentLocale }}</div>
      <div class="season-number-container" [class.wide]="isArabic$ | async" *ngIf="showSeasonNumber">
        {{ 'SD_Season_Info_txt' | translate: { season: (vm | contentExtendedData | async)?.bookmark.seasonNumber } }}
      </div>
    </div>
  </a>

  <!-- Needed to preload preview landscape image for portrait carousel item -->
  <div class="d-none" *ngIf="hovered && !isLandscape">
    <img
      osnSharedUseAsPicture
      class="bg-image"
      [src]="(vm | contentCoreData | async)?.landscapeImageUrl"
      [imgQuery]="previewImgQuery"
      [alt]="vm.title.en"
    />
  </div>
</ng-container>
